export const calculateReforestation = async (
  geoJsonObject: {
    [K in 'type' | 'features']: K extends 'type'
      ? 'FeatureCollection'
      : Array<{
          type: 'Feature';
          properties: Record<string, any>;
          geometry: {
            type: string;
            coordinates: number[][];
          };
        }>;
  },
  selectedReProject: any,
) => {
  if (selectedReProject) {
    try {
      // above ground biomass in tonnes and soil organic carbon in tonnes

      const featuresArray = geoJsonObject?.features;
      let sumOfReforestationHigh: number = 0;
      let sumOfReforestationMedium: number = 0;
      let sumOfReforestationLow: number = 0;
      let sumOfConservation: number = 0;
      let sumOfAboveGroundBiomassTonnes: number = 0;
      let sumOfSoilOrganicCarbonTonnes: number = 0;
      featuresArray?.map((feature: any) => {
        // console.log('feature =>', feature?.properties?.score_category);
        switch (feature?.properties?.score_category) {
          case 'High':
            sumOfReforestationHigh = sumOfReforestationHigh + feature?.properties?.area_in_hector;
            break;
          case 'Medium':
            sumOfReforestationMedium =
              sumOfReforestationMedium + feature?.properties?.area_in_hector;
            break;
          case 'Low':
            sumOfReforestationLow = sumOfReforestationLow + feature?.properties?.area_in_hector;
            break;
          case 'Conservation':
            sumOfConservation = sumOfConservation + feature?.properties?.area_in_hector;
            break;
        }
        sumOfAboveGroundBiomassTonnes =
          sumOfAboveGroundBiomassTonnes + feature?.properties?.agb_in_t;
        sumOfSoilOrganicCarbonTonnes = sumOfSoilOrganicCarbonTonnes + feature?.properties?.soc_in_t;
      });
      return {
        sumOfConservation,
        sumOfReforestationHigh,
        sumOfReforestationMedium,
        sumOfReforestationLow,
        sumOfAboveGroundBiomassTonnes,
        sumOfSoilOrganicCarbonTonnes,
      };
    } catch (error) {
      console.error('Error fetching polygon features:', error);
    }
  } else {
    console.error('A recommended project not has been selected:');
  }
};
